export const HOST = (() => {
  if (process.env.NODE_ENV === 'development') {
    return `${location.protocol}//local.ycbaoxiao.com/`
  }
  if (location.host === 'bx.admin.zerocs.cn/') {
    return `${location.protocol}//bx.zerocs.cn/`
  }
  return `${location.protocol}//bx.zerocs.cn/`
})()



// WEBPACK FOOTER //
// ./src/assets/js/config.js